/* Shopify provides the cart, current prices and search results. */
(function () {
  'use strict';
  var lines = [];
  var queue = Promise.resolve();
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  root = root.replace(/\/?$/, '/');

  function shape(cart) {
    lines = (cart.items || []).map(function (item) {
      return {
        id: String(item.variant_id), key: item.key, qty: item.quantity,
        price: item.final_price / 100, title: item.product_title,
        opt: item.variant_title === 'Default Title' ? '' : (item.variant_title || ''),
        imgUrl: item.image || null
      };
    });
    return lines;
  }

  async function request(path, body, signal) {
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: signal };
    if (body !== undefined) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    var response = await fetch(root + path, options);
    var data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Požadavek se nepodařilo dokončit.');
    return data;
  }

  function mutate(action) {
    var result = queue.then(action, action);
    queue = result.catch(function () {});
    return result;
  }

  window.JDO_SHOPIFY = {
    checkoutUrl: root + 'checkout',
    lines: function () { return lines; },
    refresh: function () { return request('cart.js').then(shape); },
    add: function (id, quantity) {
      if (!/^\d+$/.test(String(id))) return Promise.reject(new Error('Toto balení momentálně nelze objednat.'));
      return mutate(async function () {
        await request('cart/add.js', { items: [{ id: Number(id), quantity: quantity }] });
        return shape(await request('cart.js'));
      });
    },
    write: function (next) {
      var desired = next.map(function (line) { return { key: line.key, qty: line.qty }; });
      var updates = {};
      lines.forEach(function (old) {
        var now = desired.find(function (line) { return line.key === old.key; });
        var quantity = now ? now.qty : 0;
        if (quantity !== old.qty) updates[old.key] = quantity;
      });
      return mutate(function () {
        return request('cart/update.js', { updates: updates }).then(shape);
      });
    },
    search: async function (query, signal) {
      var params = new URLSearchParams({ q: query, 'resources[type]': 'product,page,article', 'resources[limit]': '8' });
      var data = await request('search/suggest.json?' + params.toString(), undefined, signal);
      var results = data.resources && data.resources.results || {};
      return ['products', 'pages', 'articles'].flatMap(function (type) {
        return (results[type] || []).map(function (item) { return [item.title, item.url, '', '']; });
      });
    }
  };
})();
